import React from "react";
import {
  AutocompleteRenderGetTagProps,
  Box,
  Checkbox,
  Chip,
  Typography,
} from "@mui/material";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";

import InputField from "../../../common/Form/Input/InputField";
import DropdownWithOther from "../../IRB/IRBSubmission/CreateIRBSubmission/StudyDetails/DropdownWithOther";
import FormDropdownField from "../../../common/Form/Dropdown/FormDropdownField";

import {
  ALL_STUDY_PHASE,
  SUBMISSION_TYPES,
  TYPES_OF_FUNDING,
  ALL_TYPE_OF_STUDY,
} from "../../../../constants";
import {
  useGetIrbSubmissionInfoLazyQuery,
  useGetProtocolListQuery,
  useGetSubmissionDropdownListQuery,
} from "../../../../generated/graphql";
import {
  DEPARTMENT,
  EMAILS,
  FUND_TYPE,
  IS_TERMS_ACCEPTED,
  MICR,
  PRINCIPAL_INVESTIGATOR,
  CO_INVESTIGATOR,
  PROTOCOL_NUMBER,
  PROTOCOL_NUMBER_OTHERS,
  SPONSOR,
  STUDY_PHASE,
  TITLE,
  TYPE_OF_STUDY,
} from "../../../../constants/forms";
import { Link } from "react-router-dom";
import config from "../../../../utils/config";

type studyDetailsProps = {
  value?: number;
};

const StudyDetails = (props: studyDetailsProps): JSX.Element => {
  const { value } = props;
  let subType = "";
  switch (value) {
    case 0:
      subType = "INITIAL_REVIEW";
      break;
    case 1:
      subType = "ADDITIONAL_DOCUMENTS";
      break;
    case 2:
      subType = "EC_NOTIFICATION";
      break;
    case 3:
      subType = "EC_ANNUAL_REPORT";
      break;
    case 4:
      subType = "PVPD_DETAILS";
      break;
    case 5:
      subType = "SAE";
      break;
    default:
      subType = "";
      break;
  }
  const { data, loading, error } = useGetProtocolListQuery({
    variables: {
      subType: subType,
      submissionType: SUBMISSION_TYPES.EC,
    },
  });

  const protocolNumbers = data?.getProtocolList.map((item, i) => {
    return item.protocolNumber;
  });

  let id: string;
  const getIdFromValue = (number: string) => {
    data?.getProtocolList.forEach((item, i) => {
      if (item.protocolNumber === number) {
        id = item._id;
      }
    });
    return id;
  };
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();
  const [getIrbById] = useGetIrbSubmissionInfoLazyQuery();
  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
  };
  const dropdownInputHandlerPN = async (fieldName: string, value: any) => {
    const id = getIdFromValue(value);
    // api call
    const newValues = await getDataFromProtocolNumber(id);
    setValues({
      ...newValues,
      [fieldName]: value,
    });
    // setFieldValue(fieldName, value);
  };
  const checkboxInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.checked);
  };

  const getDataFromProtocolNumber = async (id: string) => {
    const { data } = await getIrbById({
      variables: { id },
    });
    if (data) {
      const {
        department,
        emails,
        isFunded,
        fundType,
        principalInvestigator,
        sponsor,
        studyPhase,
        title,
        micr,
        typeOfStudy,
      } = data.irb;
      return {
        ...values,
        department,
        emails,
        isFunded,
        fundType,
        principalInvestigator,
        sponsor,
        studyPhase,
        title,
        micr,
        typeOfStudy,
        isTermsAccepted: true,
      };
    }
    return values;
  };
  const { data: dropdownLists } = useGetSubmissionDropdownListQuery({
    variables: {},
  });
  const isExistingProtocolNumber = !(
    values[PROTOCOL_NUMBER_OTHERS] === values[PROTOCOL_NUMBER]
  );

  return (
    <>
      <DropdownWithOther
        label="1.1 Protocol Number/Short Title"
        placeholder="Protocol Number/Short Title"
        name={PROTOCOL_NUMBER}
        callBack={dropdownInputHandlerPN}
        options={[...(protocolNumbers || []), "Others"]} //make this dynamic
        disabled={false}
      />

      <InputField
        label={"1.2 MICR #"}
        name={MICR}
        placeholder={"Short Text"}
        value={values[MICR]}
        disabled={isExistingProtocolNumber}
      />

      <Box className="mg-b-50">
        <InputField
          label={"1.3 Study Title"}
          name={TITLE}
          placeholder={"Short Text"}
          value={values[TITLE]}
          disabled={isExistingProtocolNumber}
        />
      </Box>

      <Box className="mg-b-50">
        <DropdownWithOther
          options={[
            ...(dropdownLists?.getSubmissionDropdownList.sponsor || []),
            "Others",
          ]}
          label={"1.4 Sponsor"}
          name={SPONSOR}
          placeholder={"Short Text"}
          disabled={isExistingProtocolNumber}
        />
      </Box>
      <Box className="mg-b-50">
        <DropdownWithOther
          options={[
            ...(dropdownLists?.getSubmissionDropdownList
              .principalInvestigator || []),
            "Others",
          ]}
          label={"1.5 Principal Investigator"}
          name={PRINCIPAL_INVESTIGATOR}
          placeholder={"Short Text"}
          disabled={isExistingProtocolNumber}
        />
      </Box>
      <Box className="mg-b-50">
        <DropdownWithOther
          options={[
            ...(dropdownLists?.getSubmissionDropdownList
              .coInvestigator || []),
            "Others",
          ]}
          label={"1.6 Co Investigator"}
          name={CO_INVESTIGATOR}
          placeholder={"Short Text"}
          disabled={isExistingProtocolNumber}
        />
      </Box>
      <Box className="mg-b-50">
        <InputField
          label={"1.7 Department"}
          name={DEPARTMENT}
          placeholder={"Short Text"}
          value={values[DEPARTMENT]}
          disabled={isExistingProtocolNumber}
        />
      </Box>

      <DropdownWithOther
        name={STUDY_PHASE}
        label={"1.8  Study Phase"}
        placeholder={"Study phase"}
        options={ALL_STUDY_PHASE}
        disabled={false}
      />

      <DropdownWithOther
        label={"1.9 Type Of Study"}
        name={TYPE_OF_STUDY}
        placeholder={"Type of Study"}
        options={ALL_TYPE_OF_STUDY}
        disabled={false}
      />

      <DropdownWithOther
        label="1.10 Type of Funding"
        name={FUND_TYPE}
        placeholder={"Type of Funding"}
        options={TYPES_OF_FUNDING}
        disabled={false}
      />

      <Box className={"custom-checkbox mg-b-50"}>
        <Checkbox
          checked={values[IS_TERMS_ACCEPTED]}
          name={IS_TERMS_ACCEPTED}
          onChange={checkboxInputHandler}
          //   disabled={!!id}
        />
        <Link to={config.terms} className="form-label font-size-14 font-weight-medium cursor-pointer text-danger">
          Terms and Conditions
        </Link>
        <ErrorMessage
          name={IS_TERMS_ACCEPTED}
          render={(msg) => {
            return (
              <div>
                <span className="text-danger font-size-sm">{msg}</span>
              </div>
            );
          }}
        />
      </Box>
    </>
  );
};

export default StudyDetails;
